import { useEffect, useState } from 'react';
import { Breadcrumb } from 'components/Breadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { STATUS_OBJ } from 'utils/statusEnum';
import { ApplicationState } from 'store/store.inteface';
import {
  clearAllSteps,
  recoverDraft,
  setCurrentStep,
} from 'store/modules/openClaim/actions';
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { Step4 } from './Step4';
import { Step5 } from './Step5';
import { Container, TabsWrapper, Tab, Content, Warning } from './styles';
import ModalError from './components/ModalError';

type RouteParams = Record<string, string>;

export const OpenClaim = (): JSX.Element => {
  const { id } = useParams<RouteParams>();
  const history = useHistoryWithHost();

  const stateClaim = useSelector((state: ApplicationState) => state.openClaim);

  const { stores } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );

  const [draftRecovered, setDraftRecovered] = useState(false);

  const dispatch = useDispatch();

  const [modalOpen, setModalOpen] = useState(false);

  const [errorMessage, setErrorMessage] = useState({
    reason: '',
    response: '',
  });

  const tabs = [
    { id: 1, name: 'Lojas e Tipos de sinistros' },
    { id: 2, name: 'Descrição da Ocorrência' },
    { id: 3, name: 'Dados da Loja' },
    { id: 4, name: 'Documentação' },
    { id: 5, name: 'Resumo' },
  ];

  useEffect(() => {
    if (id && !draftRecovered && stores.length > 0) {
      // existe id mas nao recuperou um rascunho ainda
      dispatch(recoverDraft(id));
      setDraftRecovered(true);
    }
    if (!id) {
      dispatch(clearAllSteps());
      dispatch(setCurrentStep(1));
    }
  }, [id, dispatch, draftRecovered, stores]);

  useEffect(() => {}, [stateClaim.currentStep, stateClaim.unlockedSteps]);

  useEffect(() => {
    if (stateClaim.currentStep === 0 && !id) {
      dispatch(setCurrentStep(1));
    } else if (stateClaim.currentStep === 5 && id) {
      dispatch(recoverDraft(id));
      setDraftRecovered(true);
    }
    window.scrollTo(0, 0);
  }, [stateClaim.currentStep]);

  useEffect(() => {
    return () => {
      dispatch(clearAllSteps());
    };
  }, [dispatch]);

  useEffect(() => {
    if (stateClaim.draftId) {
      history.push(`/openclaim/${stateClaim.draftId}`);
    }
  }, [stateClaim.draftId]);

  useEffect(() => {
    if (stateClaim.errorDraft) {
      setModalOpen(true);
      if (stateClaim.errorDraft?.response) {
        setErrorMessage({
          response: stateClaim.errorDraft?.response?.data?.response,
          reason: stateClaim.errorDraft?.response?.data?.reason,
        });
      } else {
        setErrorMessage({
          response: '',
          reason: 'Erro inesperado, tente novamente mais tarde',
        });
      }
    }
  }, [stateClaim.errorDraft]);

  return (
    <Container>
      <Breadcrumb color="light" />

      {stateClaim.status === STATUS_OBJ.Draft && (
        <Content>
          <TabsWrapper>
            {tabs.map(tab => {
              return (
                <Tab
                  key={tab.id}
                  className={`
                  ${stateClaim.currentStep === tab.id ? 'active' : ''}
                  ${stateClaim.unlockedSteps >= tab.id ? 'unlocked' : ''}
                `}
                  // onClick={() => changeTab(tab.id)}
                >
                  {tab.name}
                </Tab>
              );
            })}
          </TabsWrapper>
          {stateClaim.currentStep === 1 && <Step1 />}
          {stateClaim.currentStep === 2 && <Step2 />}
          {stateClaim.currentStep === 3 && <Step3 />}
          {stateClaim.currentStep === 4 && <Step4 />}
          {stateClaim.currentStep === 5 && <Step5 />}
          <ModalError
            isOpen={modalOpen}
            setIsOpen={setModalOpen}
            errorReason={errorMessage.reason}
            errorResponse={errorMessage.response}
          />
        </Content>
      )}
      {stateClaim.status !== STATUS_OBJ.Draft && (
        <Content>
          <Warning>Abertura de sinistro concluída</Warning>
        </Content>
      )}
    </Container>
  );
};
